/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {TechnicianGroupBaseContract} from '../../../api/ms-partnumberchanges/contracts/technician-group-base.contract';
import {TechnicianGroupBaseModel} from './technician-group-base.model';


export class TechnicianGroupModelMapper {

    static fromTechnicianGroupBaseContractArray(input: TechnicianGroupBaseContract[]): TechnicianGroupBaseModel[] {
        return input?.map((element) => TechnicianGroupModelMapper.fromTechnicianGroupBaseContract(element));
    }

    static fromTechnicianGroupBaseContract(input: TechnicianGroupBaseContract): TechnicianGroupBaseModel {
        return {
            name: input?.name,
            code: input?.code,
            active: input?.active,
            modelCodes: input?.modelCodes
        };
    }
}
